import React, { useEffect } from "react";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopingSolution from "../components/developingsolution/DevelopingSolution";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import SecondFaq from "../components/secondFaq/SecondFaq";
import Footer from "../components/footer/Footer";
import { Helmet } from "react-helmet-async";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import RoadMap from "../components/roadMap/RoadMap";
import WhoWeServe from "../components/who-we-serve/WhoWeServe";
import HighValues from "../components/high-values/HighValues";
import TypesOfBuild from "../components/types-of-build/TypesOfBuild";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import { IndustryTabsData } from "../data/industriesTabsData";
import DevelopmentServices from "../components/development-services/DevelopmentServices";
import ContactSection from "../components/contactSection/ContactSection";
import { WebServicesIndustryTabsItemsData } from "../data/web-app-service-page";
import NewEngagementModels from "../components/new-engagment-modal";
import {
  DevelopmentServicesData,
  faqData,
  HighvaluesData,
  mainBannerImg,
  mobileAppDevelopmentPageServices,
  schemaData,
  tabItems,
  tabs,
  TypesOfBuildData,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "../data/mobile-app-development-data";
import { useTranslation } from "react-i18next";
import SimpleModels from "../components/simpleEngagementModels";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import { AiMlPageData } from "../data/ai-ml-data";

const MobileDevelopmentServices = () => {
  const { t } = useTranslation("mobileAppDevelopmentPage");
  const bannerContent = t("mobileAppBanner", { returnObjects: true });
  const developmentServicesContent = t("mobileAppServicesSection", {
    returnObjects: true,
  });
  const typeOfBuildAccordian = t("mobileAppTypeOfBuildSection", {
    returnObjects: true,
  });
  const whoWeServe = t("mobileAppWhoWeServeSection", { returnObjects: true });
  const whyChooseUs = t("mobileAppWhyChooseUsSection", { returnObjects: true });
  const highValueSection = t("mobileAppHighValueSection", {
    returnObjects: true,
  });
  const roadMapContent = t("mobileAppRoadMapSection", { returnObjects: true });
  const coverTheStack = t("mobileAppCoverTheStack", { returnObjects: true });
  const industriesHeading = t("mobileAppIndustriesHeading", {
    returnObjects: true,
  });
  const faqSection = t("mobileAppFaqSection", { returnObjects: true });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("mobileAppDevTitle", { returnObjects: false });

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Mobile App Development Services with Certified Agile QA Professionals​</title>
        <meta
          name="description"
          content="Bitsclan is a leading mobile app development company offering custom iOS, Android, cross-platform and flutter app development solutions. Hire experienced mobile app developers within your budget!"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading="Mobile App Development Services"
        mainHeading="Trusted by <span>Startups,</span> SMBs, & Enterprises Around the Globe"
        description="Let us take your eureka moment from a raw concept to feasibility assessment, & from design to development. Our custom software development services offer robust, secure, scalable solutions to ensure sustainable growth for your business."
      />
      <TrustedPartner />

      <OurServices
        buttonText="Start Your Journey"
        servicesCardsData={mobileAppDevelopmentPageServices?.cardsData}
        shortHeading={mobileAppDevelopmentPageServices?.shortHeading}
        mainHeading={mobileAppDevelopmentPageServices?.mainHeading}
        description={mobileAppDevelopmentPageServices?.description}
      />

      <NewTestimonials
        shortHeading="Our Testimonials"
        mainHeading="Voices of <span>Global</span> Enterprises on Our Custom Software Development Excellence"
        description="Discover why businesses trust Bitsclan for cutting-edge Custom Software Development solutions. Read real feedback from clients who achieved success with our services."
      />

      <WhyChooseUs
        heading="Advantage of Partnering With Us"
        greenHeading="The Strategic "
        shortHeading="why Choose Us"
        content="Organizations trust us for delivering AI-powered chatbots, intelligent automation, & advanced web & mobile app solutions. By blending innovation with proven IT strategies, we turn business challenges into scalable opportunities for long-term growth."
        stats={[
          // {
          //   number: "2017",
          //   title: "Delivering Excellence Since"
          // },
          {
            number: "120+",
            title: "Successful Projects Delivered"
          },
          {
            number: "100+",
            title: "Associated Professionals"
          },
        ]}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <CoverTheStack
        whereStart={coverTheStack?.defaultOpenTab}
        mainHeading={coverTheStack?.mainHeading}
        subHeading={coverTheStack?.sectionDescription}
        tabs={coverTheStack?.tabs}
        tabItems={coverTheStack?.tabItems}
      />

      <SimpleModels content={engagementModelsContent} />

      <PioneeringChange
        tabData={AiMlPageData.industries.tabData}
        shortHeading="Industries We Serve"
        mainHeading={industriesHeading?.mainHeading}
        content={
          "Driving innovation & transforming industries with advanced Mobile Applications expertise & actionable insights."
        }
      />

      <TypesOfBuild
        typeOfApps={typeOfBuildAccordian?.accordianData}
        heading={typeOfBuildAccordian?.mainHeading}
        sideImage="mobile-app-development-type.avif"
      />

      <WhoWeServe
        cardContent={whoWeServe?.cardsData}
        heading={whoWeServe?.mainHeading}
        subHeading={whoWeServe?.sectionDescription}
      />

      <WhyChooseBitsclan
        tabs={whyChooseUs?.tabsData}
        expandAllAccordions={true}
        heading={whyChooseUs?.mainHeading}
        subheading={whyChooseUs?.sectionDescription}
      />

      <HighValues
        heading={highValueSection?.mainHeading}
        subHeading={highValueSection?.sectionDescription}
        boxContent={highValueSection?.highValueCards}
        btnLink="#"
        btnText={highValueSection?.buttonText}
      />

      {/* <NewEngagementModels /> */}

      <RoadMap
        heading={roadMapContent?.mainHeading}
        description={roadMapContent?.sectionDescription}
        roadMapHeading={[]}
        roadMapsteps={[]}
      />

      <DevelopingSolution
        heading="Developing Solutions That Transcend Mere Digital Transformation"
        subheading="We deliver innovative solutions that surpass digital transformation, driving impactful & lasting success."
      />

      <TrendsInsights
        specificClass="mobile-dev-page"
        category="mobile-app-developmet"
      />

      <SecondFaq
        specificClass="mobile-dev-page"
        faqs={faqSection?.questionAnswer}
        mainHeading={faqSection?.mainHeading}
        subHeading={faqSection?.sectionDescription}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default MobileDevelopmentServices;
